module.exports = __webpack_public_path__ + "fb289ca05aec82435254286e5410df58.svg";